(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3710],{

/***/ 56795:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startups",
      function () {
        return __webpack_require__(64589);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ClerkComponentsFeature; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77248);
/* harmony import */ var _sanity_sane_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27013);







const ClerkComponentsFeature = (param)=>/*#__PURE__*/ {
    let { featureTitle , featureDesc , image , imageFileURL , items , imagePosition , bottomCta  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col gap-8 lg:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex-1 ", imagePosition === "left" && "lg:order-2"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "mb-3 text-2xl font-extrabold leading-9 tracking-tight text-gray-900 lg:text-3xl",
                            children: featureTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-10 text-base font-normal leading-6 text-gray-500",
                            children: featureDesc
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col gap-10",
                            children: items.map((param)=>/*#__PURE__*/ {
                                let { itemTitle , itemDesc , icon  } = param;
                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mr-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "flex items-center justify-center w-12 h-12 rounded-md bg-clerk-blue",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .DynamicHeroIcon */ .Y, {
                                                    icon: icon,
                                                    className: "w-5 h-5 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(!itemDesc && "flex items-center"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("text-lg font-medium leading-6 text-gray-900", itemDesc ? "mb-2" : "mb-0"),
                                                    children: itemTitle
                                                }),
                                                itemDesc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-base font-normal leading-6 text-gray-500",
                                                    dangerouslySetInnerHTML: {
                                                        __html: itemDesc
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }, itemTitle);
                            })
                        }),
                        bottomCta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-8",
                            children: [
                                bottomCta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mr-1 text-gray-500",
                                    children: bottomCta.description
                                }),
                                bottomCta.internalHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    legacyBehavior: true,
                                    href: bottomCta.internalHref,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "text-clerk-blue",
                                        children: [
                                            bottomCta.cta,
                                            bottomCta.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .DynamicHeroIcon */ .Y, {
                                                icon: bottomCta.icon,
                                                weight: "outline",
                                                className: "relative inline w-5 h-5 bottom-[1px]"
                                            })
                                        ]
                                    })
                                }),
                                bottomCta.externalHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: bottomCta.internalHref,
                                    target: "_blank",
                                    rel: "noopener",
                                    children: [
                                        bottomCta.cta,
                                        bottomCta.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .DynamicHeroIcon */ .Y, {
                                            icon: bottomCta.icon,
                                            weight: "outline",
                                            className: "relative inline w-5 h-5 bottom-[1px]"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex-1",
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sanity_sane_image__WEBPACK_IMPORTED_MODULE_3__/* .SaneImage */ .Q, {
                            wrapClassName: "h-60 sm:h-80 md:h-96 lg:h-full",
                            className: "rounded-3xl",
                            src: image,
                            height: undefined,
                            width: undefined,
                            layout: "fill"
                        }),
                        imageFileURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-60 sm:h-80 md:h-96 lg:h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                className: "rounded-3xl",
                                src: imageFileURL,
                                alt: "dsg",
                                layout: "fill"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 77248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DynamicHeroIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83319);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2905);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92777);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9014);




const DynamicHeroIcon = (param)=>{
    let { icon , className ="" , weight ="solid"  } = param;
    // eslint-disable-next-line
    const Icon = // @ts-ignore
    weight === "solid" ? _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__[icon] : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__[icon];
    if (!icon || !Icon) {
        const FallbackIcon = weight === "solid" ? _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FallbackIcon, {
            "aria-hidden": "true",
            className: className
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            "aria-hidden": "true",
            className: className
        })
    });
};
DynamicHeroIcon.defaultProps = {
    className: undefined,
    weight: undefined
};


/***/ }),

/***/ 27013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SaneImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53822);



function SaneImage(param) {
    let { src , height , width , layout , wrapClassName , ...props } = param;
    const { dimensions , format  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .decodeAssetId */ .h9)(src.asset._ref);
    const url = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .urlForImage */ .iQ)(src.asset).url() || "";
    const newHeight = height ? height : width ? width / dimensions.width * dimensions.height : format === "svg" || src.lowresolution ? dimensions.height : dimensions.height / 2;
    const newWidth = width ? width : height ? height / dimensions.height * dimensions.width : format === "svg" || src.lowresolution ? dimensions.width : dimensions.width / 2;
    const customDimensions = layout ? {
        layout
    } : {
        height: newHeight,
        width: newWidth
    };
    return format === "gif" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: url,
        height: newHeight,
        width: newWidth,
        alt: src.alt
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: wrapClassName || "image-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            alt: src.alt,
            ...props,
            ...customDimensions,
            src: url
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SaneImage);


/***/ }),

/***/ 10814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Code; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prism-react-renderer/dist/index.js + 2 modules
var dist = __webpack_require__(27087);
// EXTERNAL MODULE: ./node_modules/prism-react-renderer/themes/oceanicNext/index.js
var oceanicNext = __webpack_require__(2097);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js + 55 modules
var dist_index_esm = __webpack_require__(43489);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/DocumentDuplicateIcon.js
var DocumentDuplicateIcon = __webpack_require__(47078);
;// CONCATENATED MODULE: ./components/common/copy-button.tsx




function CopyButton(param) {
    let { copyText  } = param;
    const [copied, setCopied] = react.useState(false);
    const handleClick = ()=>{
        navigator.clipboard.writeText(copyText);
        setCopied(true);
    };
    react.useEffect(()=>{
        let timer;
        if (copied) {
            timer = setTimeout(()=>{
                setCopied(false);
            }, 1000);
        }
        return ()=>clearTimeout(timer);
    }, [
        copied,
        setCopied
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Tooltip */.u, {
        label: copied ? "Copied" : "Copy",
        "aria-label": "Copy to clipboard",
        closeOnClick: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
            as: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                as: DocumentDuplicateIcon/* default */.Z,
                boxSize: 5,
                onClick: handleClick
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/sanity/serializers/code.tsx







const WithLineNumbers = (param)=>/*#__PURE__*/ {
    let { children , index , lineProps  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        ...lineProps,
        className: classnames_default()(lineProps.className, "table-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "table-cell pr-3 text-right opacity-50 select-none",
                children: index + 1
            }),
            children
        ]
    }, "line".concat(index));
};
function Code(param) {
    let { className: userClassName , language ="jsx" , children , filename , theme , highlightedLines , codeWithVisibleKeysFormatted , withLineNumbers =false , withTabs =false , withCopy =false , showKeysVisibilityToggle =false , toggleComponent =null  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                align: "center",
                gap: 2,
                pos: "absolute",
                right: 0,
                top: 0,
                p: 4,
                roundedTopRight: "md",
                bg: "#282c34",
                color: "#fff",
                children: [
                    showKeysVisibilityToggle ? toggleComponent : null,
                    withCopy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                        copyText: typeof codeWithVisibleKeysFormatted === "string" ? codeWithVisibleKeysFormatted : children
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                ...dist/* defaultProps */.lG,
                theme: oceanicNext/* default */.Z,
                code: children,
                language: language,
                children: (param)=>/*#__PURE__*/ {
                    let { className , style , tokens , getLineProps , getTokenProps  } = param;
                    return (0,jsx_runtime.jsxs)("pre", {
                        className: classnames_default()(className, "leading-[1.8]", userClassName ? userClassName : "overflow-x-auto p-4 pr-12 m-6 mx-0 mt-8 bg-white rounded-md text-sm", withTabs && "rounded-tl-none mt-0"),
                        style: style,
                        children: [
                            filename ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block mb-2 text-gray-400",
                                children: filename
                            }) : null,
                            tokens.map((line, i)=>{
                                const lineProps = getLineProps({
                                    line,
                                    key: i
                                });
                                if (highlightedLines && highlightedLines.includes(i + 1)) {
                                    lineProps.style = {
                                        ...lineProps.style,
                                        backgroundColor: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"
                                    };
                                }
                                return withLineNumbers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WithLineNumbers, {
                                    index: i,
                                    lineProps: lineProps,
                                    children: line.map((token, key)=>{
                                        if (token.content !== "" || !token.empty) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ...getTokenProps({
                                                    token,
                                                    key
                                                })
                                            }, "token".concat(key));
                                        }
                                    })
                                }, "line".concat(i)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    pl: 2,
                                    ...lineProps,
                                    children: line.map((token, key)=>{
                                        if (token.content !== "" || !token.empty) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ...getTokenProps({
                                                    token,
                                                    key
                                                })
                                            }, "token".concat(key));
                                        }
                                    })
                                }, "line".concat(i));
                            })
                        ]
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 64589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ StartupsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/startups/top-cta.tsx

function TopCTA(param) {
    let { applyURL  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-5xl font-extrabold tracking-tight text-gray-900 md:text-6xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline",
                        children: "Clerk for"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline text-clerk-blue",
                        children: "Startups"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                children: [
                    "Launch your application with beautiful user management features.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                children: [
                    "Save ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "time"
                    }),
                    " and ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "money"
                    }),
                    " with up to 6 months free."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: applyURL,
                        target: "_blank",
                        rel: "noopener",
                        className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn",
                        children: "Apply now"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./components/startups/big-quote.tsx



const BigQuote = (param)=>/*#__PURE__*/ {
    let { quote , name , titles , imageURL  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "relative px-4 pt-20 pb-12 mx-auto overflow-hidden max-w-7xl sm:px-6 lg:px-8 lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative items-center lg:flex lg:items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden overflow-hidden rounded-full lg:flex lg:flex-shrink-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageURL,
                        width: "200",
                        height: "200",
                        alt: "av"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative lg:ml-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "absolute top-0 left-0 transform -translate-x-8 -translate-y-24 h-36 w-36 text-clerk-blue opacity-20",
                            stroke: "currentColor",
                            fill: "none",
                            viewBox: "0 0 144 144",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeWidth: 2,
                                d: "M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-2xl font-medium leading-9 text-gray-900",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: quote
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                    className: "mt-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center flex-shrink-0 overflow-hidden rounded-full w-14 lg:hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: imageURL,
                                                    width: "200",
                                                    height: "200",
                                                    alt: "av"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ml-4 lg:ml-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base font-medium text-gray-900",
                                                        children: name
                                                    }),
                                                    titles.map((title)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-base font-medium text-clerk-blue",
                                                            children: title
                                                        }, title))
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var big_quote = ((/* unused pure expression or super */ null && (BigQuote)));

;// CONCATENATED MODULE: ./components/startups/partners-logo-cloud.tsx
/* eslint-disable @next/next/no-img-element */ 

const logos = [
    {
        src: "/partner-logos/logo-yc.svg",
        alt: "ptnr",
        maxWidth: "50px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-spc.svg",
        alt: "ptnr",
        maxWidth: "50px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-ondeck.svg",
        alt: "ptnr",
        maxWidth: "100px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-techstars.svg",
        alt: "ptnr",
        maxWidth: "100px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-heavybit.svg",
        alt: "ptnr",
        maxWidth: "50px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-l2ventures.svg",
        alt: "ptnr",
        maxWidth: "50px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-haystack.svg",
        alt: "ptnr",
        maxWidth: "50px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-pioneer.svg",
        alt: "ptnr",
        maxWidth: "100px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-lh.svg",
        alt: "ptnr",
        maxWidth: "50px",
        maxHeight: "50px"
    },
    {
        src: "/partner-logos/logo-seedcamp.svg",
        alt: "sc",
        maxWidth: "280px",
        maxHeight: "50px"
    }
];
const PartnersLogoCloud = (props)=>{
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-2xl px-4 py-16 mx-auto lg:py-24 sm:px-6 lg:max-w-7xl lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-sm font-bold text-center text-gray-600",
                    children: "OUR PARTNERS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap overflow-hidden lg:px-20",
                    children: logos.map((param)=>/*#__PURE__*/ {
                        let { src , alt , maxWidth , maxHeight  } = param;
                        return (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center w-1/2 mt-20 md:w-1/5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                style: {
                                    maxWidth,
                                    maxHeight
                                },
                                src: src,
                                alt: alt
                            })
                        }, src);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/CheckIcon.js
var CheckIcon = __webpack_require__(64343);
;// CONCATENATED MODULE: ./components/startups/features.tsx



const featuresData = [
    {
        name: "Email and SMS authentication",
        description: "Give users a beautiful. secure login experience using emails or phone numbers."
    },
    {
        name: "Social Logins",
        description: "Grant faster access with Google, Facebook, Github, Twitter and more."
    },
    {
        name: "Multi-sessions",
        description: "Allow users to sign in to multiple accounts at once"
    },
    {
        name: "Passwordless authentication",
        description: "Make passwords obsolete by sending Email Magic Links and One-time Password Codes (OTPs)."
    },
    {
        name: "Multi Factor authentication",
        description: "Encourage or require a second step during sign in."
    },
    {
        name: "Device management",
        description: "Proactively notify users when a new device signs in."
    }
];
const Features = (props)=>{
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-16 mx-auto max-w-7xl lg:py-24 sm:px-6 lg:px-8 lg:grid lg:grid-cols-3 lg:gap-x-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-base font-semibold tracking-wide uppercase text-clerk-blue",
                            children: "Everything you need"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mt-2 text-3xl font-extrabold text-gray-900",
                            children: "The features your users expect"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-4 text-gray-500 text",
                            children: "Signing up and signing in are the first interactions users will have with your product. Delight them with the familiar features they have come to expect."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-12 lg:mt-0 lg:col-span-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-3 sm:grid-flow-col sm:gap-x-6 sm:gap-y-10 lg:gap-x-8",
                        children: featuresData === null || featuresData === void 0 ? void 0 : featuresData.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                                className: "absolute w-6 h-6 text-green-500",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "font-medium leading-6 text-gray-900 text ml-9",
                                                children: feature.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        className: "mt-2 text-base text-gray-500 ml-9",
                                        children: feature.description
                                    })
                                ]
                            }, feature.name))
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/common/clerk-components/feature.tsx
var feature = __webpack_require__(23460);
;// CONCATENATED MODULE: ./components/startups/customizable.tsx



const customizable_feature = {
    featureTitle: "Customizable to your business",
    featureDesc: "Styling is just the start – we understand that every business has unique needs for their sign-up flow and can accommodate most requests out-of-the-box.",
    bottomCta: {
        description: "Looking for something you don’t see here?",
        cta: "Contact us",
        internalHref: "/support",
        icon: "ArrowSmRightIcon"
    },
    items: [
        {
            itemTitle: "Your choice of authentication strategies",
            itemDesc: "Different businesses needs users to sign in different ways – choose only the ones that are right for your application.",
            icon: "ShieldCheckIcon"
        },
        {
            itemTitle: "Match your brand",
            itemDesc: "Add your logo and choose your font, colors, and other styles to match your brand.",
            icon: "ColorSwatchIcon"
        },
        {
            itemTitle: "Integrate your way",
            itemDesc: "Embed the component in your page, overlay it in a modal, or forward users to the Clerk-hosted User Management Portal.",
            icon: "PuzzleIcon"
        }
    ]
};
const Customizable = (props)=>{
    const { className  } = props;
    let { imagePosition  } = props;
    if (!imagePosition) {
        imagePosition = "right";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col px-6 py-16 mx-auto lg:py-24 max-w-7xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature/* ClerkComponentsFeature */.N, {
                imageFileURL: "/images/customizable.svg",
                imagePosition: imagePosition,
                ...customizable_feature
            }, customizable_feature.featureTitle)
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ShareIcon.js
var ShareIcon = __webpack_require__(20839);
// EXTERNAL MODULE: ./components/sanity/serializers/code.tsx + 1 modules
var code = __webpack_require__(10814);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/startups/easy-to-use.tsx





const easy_to_use_code = '\nimport { SignedIn, SignedOut, SignIn } \nfrom "@clerk/clerk-react";\n\nfunction Dashboard() {\n  return (\n    <main>\n      <SignedIn>        \n        <MyDashboard /> {/* Show dashboard */}\n      </SignedIn>\n      <SignedOut>        \n        <SignIn /> {/* Show sign-in flow */}\n      </SignedOut>\n    </main>\n  )\n}\n';
const EasyToUse = (props)=>{
    const { className  } = props;
    let { imagePosition  } = props;
    if (!imagePosition) {
        imagePosition = "right";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-8 lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("max-w-xl px-4 mx-auto sm:px-6 py-8 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0", imagePosition === "right" ? "lg:col-start-1" : "lg:col-start-2"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex items-center justify-center w-12 h-12 rounded-md bg-clerk-blue",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcon/* default */.Z, {
                                        className: "w-6 h-6 text-white",
                                        "aria-hidden": "true"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                        children: "Easy-to-use APIs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-4 text-gray-500 text",
                                        children: "We obsess over every detail of our API definition, documentation, and helper libraries to ensure they are intuitive and developer-friendly."
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("mt-12 sm:mt-16 lg:mt-0", imagePosition === "right" ? "lg:col-start-2" : "lg:col-start-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
                        language: "jsx",
                        theme: "dark",
                        highlightedLines: undefined,
                        children: easy_to_use_code
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
;// CONCATENATED MODULE: ./components/startups/bottom-cta.tsx


function BottomCTA(param) {
    let { applyURL  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-10 pt-20 pb-28 text-center text-white bg-[#2B1C66] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-5xl font-bold text-white md:text-6xl",
                children: "Ready to start?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-6 text-base text-gray-300",
                children: "Apply today and get up to 6 months free"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md",
                    onClick: ()=>{
                        (0,pages.rudderTrack)("Marketing_For Startups_Apply Now Button Clicked", {
                            surface: "Marketing",
                            location: "For Startups"
                        });
                        pages.analytics.track("Marketing_For Startups_Apply Now Button Clicked", {
                            surface: "Marketing",
                            location: "For Startups"
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: applyURL,
                        target: "_blank",
                        rel: "noopener",
                        className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-clerk-blue md:py-4 md:text-lg md:px-10",
                        children: "Apply now"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/sanity/sane-image.tsx
var sane_image = __webpack_require__(27013);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./components/common/layout-container.tsx
var layout_container = __webpack_require__(50336);
;// CONCATENATED MODULE: ./components/common/investors.tsx






const Investors = (param)=>/*#__PURE__*/ {
    let { investors  } = param;
    return (0,jsx_runtime.jsxs)(layout_container/* LayoutContainer */.k, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                justifyContent: "center",
                alignItems: "center",
                mx: {
                    lg: 16
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    pos: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                        size: "h2",
                        mb: 12,
                        textAlign: "center",
                        children: [
                            "Proudly Supported ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                color: "primary.500",
                                children: "By Developer Tools Experts."
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Grid */.rj, {
                templateColumns: {
                    base: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)"
                },
                gap: 8,
                children: investors.slice(0, 2).map((investor)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            bg: "white",
                            p: "24px",
                            display: "flex",
                            flexDir: "row",
                            alignItems: "center",
                            borderRadius: "8px",
                            pos: "relative",
                            children: [
                                investor.picture && /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* default */.Z, {
                                    alt: investor.name,
                                    src: investor.picture,
                                    height: 72,
                                    width: 72
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    p: "16px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            mb: 1,
                                            fontWeight: "semibold",
                                            children: investor.name
                                        }),
                                        investor.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            legacyBehavior: true,
                                            href: "https://".concat(investor.url),
                                            target: "_blank",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                as: "a",
                                                children: investor.url
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            children: investor.role
                                        })
                                    ]
                                })
                            ]
                        }, investor.name)
                    }, investor.name))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Grid */.rj, {
                templateColumns: {
                    base: "repeat(1, 1fr)",
                    md: "repeat(3, 1fr)"
                },
                gap: 8,
                mt: 8,
                children: investors.slice(2, 8).map((investor)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            bg: "white",
                            display: "flex",
                            flexDir: "row",
                            alignItems: "center",
                            rounded: "md",
                            minH: "9vh",
                            pos: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                p: "16px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        mb: 1,
                                        fontWeight: "semibold",
                                        children: investor.name
                                    }),
                                    investor.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        legacyBehavior: true,
                                        href: "https://".concat(investor.url),
                                        target: "_blank",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            as: "a",
                                            children: investor.url
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        children: investor.role
                                    })
                                ]
                            })
                        }, investor.name)
                    }, investor.name))
            })
        ]
    });
};
/* harmony default export */ var investors = ((/* unused pure expression or super */ null && (Investors)));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
;// CONCATENATED MODULE: ./pages/startups/index.tsx




const applyURL = "https://2y2mhpgqtw5.typeform.com/to/uKXUVeca";
var __N_SSG = true;
function StartupsPage(param) {
    let { investors  } = param;
    const [isLargerThan800] = (0,dist_index_esm/* useMediaQuery */.ac)("(min-width: 800px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "px-6 mx-auto mt-36 max-w-7xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCTA, {
                    applyURL: applyURL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "py-8 mt-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BigQuote, {
                        quote: "It’s great to see a service focus on taking away all the pain related to user management—not just login.",
                        name: "Guillermo Rauch",
                        titles: [
                            "CEO, Vercel"
                        ],
                        imageURL: "/avatars/guillermo.jpeg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BigQuote, {
                        quote: "Working on account.php at Facebook was like being in a landmine field, and I love that Clerk’s User Profile solves that.",
                        name: "Aditya Agrawal",
                        titles: [
                            "Early employee, Facebook",
                            "Ex-CTO, Dropbox"
                        ],
                        imageURL: "/avatars/aditya.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersLogoCloud, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizable, {
                imagePosition: "left"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EasyToUse, {
                imagePosition: "right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Investors, {
                investors: investors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCTA, {
                applyURL: applyURL
            })
        ]
    });
}


/***/ }),

/***/ 77082:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function LinkIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (LinkIcon);

/***/ }),

/***/ 75426:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function CheckCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CheckCircleIcon);

/***/ }),

/***/ 45001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ExclamationCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExclamationCircleIcon);

/***/ }),

/***/ 33772:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ExclamationIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExclamationIcon);

/***/ }),

/***/ 71738:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function EyeIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 12a2 2 0 100-4 2 2 0 000 4z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (EyeIcon);

/***/ }),

/***/ 77481:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function EyeOffIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (EyeOffIcon);

/***/ }),

/***/ 79771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function InformationCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (InformationCircleIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6241,2868,9774,2888,179], function() { return __webpack_exec__(56795); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);